import { useState } from 'react';
import Grid from '@material-ui/core/Grid';

import Item from './Item';

const List = props => {
  const { profiles, search } = props;
  const { onSelect = () => {} } = props;
  const [selected, setSelected] = useState(null);

  const select = (profile, idx) => {
    setSelected(idx);
    onSelect(profile);
  };

  return (
    <Grid container spacing={2}>
      {profiles.map((profile, index) => (
        <Item
          key={`profile-${index}`}
          index={index}
          onClick={index === selected ? () => {} : select}
          profile={profile}
          selected={index === selected}
          searchData={search}
        />
      ))}
    </Grid>
  );
};

export default List;
